import { CloudWatchLogger } from './CloudWatchLogger';

export const logger = new CloudWatchLogger();
